import { render, staticRenderFns } from "./AppVersionUpgradeLogModal.vue?vue&type=template&id=0c9d19fb&"
import script from "./AppVersionUpgradeLogModal.vue?vue&type=script&lang=js&"
export * from "./AppVersionUpgradeLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports